export const eur = (n, d = 0) =>
  "€ " + Number(n).toLocaleString("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d, useGrouping: "always" });

export const MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export const OFFER = {
  A: { setup: 11900, fee: 690, listSetup: 14500, listFee: 850, comm: 0 },
  B: { setup: 3900, fee: 390, listSetup: 4800, listFee: 450, comm: 0.1, listComm: 0.12 },
};

export const B2B_SCENARIOS = [
  { key: "prudente", label: "Prudente", y1: 40000, y2: 60000 },
  { key: "medio", label: "Medio", y1: 60000, y2: 90000 },
  { key: "aggressivo", label: "Aggressivo", y1: 90000, y2: 130000 },
];

export const B2B_MARGIN = 0.38;
// Stagionalità B2B: Pasqua (mar-apr), eventi (mag-giu), Natale (set-dic)
const B2B_SHARE = { 2: 0.1, 3: 0.1, 4: 0.05, 5: 0.05, 8: 0.08, 9: 0.2, 10: 0.27, 11: 0.15 };
const BRAND_ONE_OFF = { 2: 5133, 3: 5133, 4: 5134 };
const SETUP_TRANCHES = { 1: 0.4, 2: 0.3, 3: 0.3 };
const WASTE_SAVING = 2600;
const ADMIN_SAVING = 1820;
const LUXURY_MARGIN = 1860;

// Mese 1 = gennaio 2027
export const b2bSales = (m, y1, y2) => (B2B_SHARE[(m - 1) % 12] || 0) * (m <= 12 ? y1 : y2);

const rampUp = (m) => (m <= 2 ? 0 : m === 3 ? 0.5 : 1);
const luxuryMargin = (m) => (m < 4 ? 0 : m < 6 ? LUXURY_MARGIN / 2 : LUXURY_MARGIN);

// Risparmi del gestionale + margine Linea Luxury: non dipendono dalla pubblicità
export const internalBenefit = (m) => rampUp(m) * (WASTE_SAVING + ADMIN_SAVING) + luxuryMargin(m);

export const appBenefit = (m) => Math.min(1000, Math.max(0, m - 2) * 200);

// Setup in tranche + canone (primi 2 mesi gratuiti)
export const partnerFixed = (m, o) => (SETUP_TRANCHES[m] || 0) * o.setup + (m >= 3 ? o.fee : 0);

export const brandCost = (m) => BRAND_ONE_OFF[m] || 0;

const mediaPlan = (m) => (m <= 6 ? 2400 : 2250);

// Flusso cumulato netto (benefici - investimenti) per 24 mesi
export function cashflow(y1, y2, opt = "A") {
  const o = OFFER[opt];
  let cum = 0;
  const out = [];
  for (let m = 1; m <= 24; m++) {
    const ben = internalBenefit(m) + appBenefit(m) + (B2B_MARGIN - o.comm) * b2bSales(m, y1, y2);
    cum += ben - partnerFixed(m, o) - mediaPlan(m) - brandCost(m);
    out.push(Math.round(cum));
  }
  return out;
}

export const paybackMonth = (series) => {
  const i = series.findIndex((v, idx) => series.slice(idx).every((x) => x >= 0));
  return i === -1 ? null : i + 1;
};

// Costo cumulato verso PartnerTech (setup + canoni con 2 mesi gratuiti + commissioni)
export function partnerCost(opt, months, sales) {
  const o = OFFER[opt];
  return o.setup + o.fee * (months - 2) + o.comm * sales;
}

export const breakEvenSales = (months) =>
  Math.round((partnerCost("A", months, 0) - partnerCost("B", months, 0)) / OFFER.B.comm);
